<template>
  <div
  class="mb-0 -mx-4 lg:mx-0 min-h-max lg:min-h-[248px] lg:rounded-xl relative bg-primary bg-no-repeat bg-cover py-6 h-full flex items-center justify-center">
    <div>
        <TsTypography appendClass="text-white mb-1" align="center" as="p" variant="h5">{{ heading }}</TsTypography>
        <TsTypography align="center" as="h2" variant="h1" appendClass="mb-0 text-white">{{ subHeading }}</TsTypography>
        <TsTypography align="center" size="sm" appendClass="text-white">{{ content }}</TsTypography>
        <form @submit.prevent="emit('search')">
          <TsInput type="text" :placeholder="placeholderText" iconPosition="right"
                   appendClass=" md:w-[425px] max-md:w-[280px] mx-auto my-5 !pr-0 shadow-md  border-0 bg-natural-soft-white "
                   dataTestid="faq-input-search-box" v-model="model">
            <template #icon>
              <div class="h-11 w-11 !m-0 !p-0 bg-primary-hover flex items-center justify-center">
                <TsButton append-class="bg-primary-hover border-none" aria-label="faq search" type="submit" icon-class="size-6" icon="material-symbols:search" data-testid="faq-search-button"/>
              </div>
            </template>
          </TsInput>
        </form>
    </div>
  </div>
</template>

<script setup lang="ts">

const model = defineModel()
const emit = defineEmits(['search'])

type Props = {
  heading?: string;
  subHeading?: string;
  content?: string;
  placeholderText?: string;
};

const props = withDefaults(defineProps<Props>(), {
  heading: 'FAQs',
  subHeading: 'Ask Us Anything',
  content: `Have any question? We're here to assist you`,
  placeholderText: 'Search here',
});
// GTM Log FOR banner click

</script>
